// intercept-checkout-redirect.js
(function() {
  var redirectUrl = '/pages/fora-de-estoque';

  function interceptClick(e) {
    var el = e.target;

    while (el && el !== document) {
      // Botão padrão de checkout
      if (el.tagName === 'BUTTON' && el.getAttribute('name') === 'checkout') {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = redirectUrl;
        return false;
      }

      // Classes comuns do tema Impulse / Shopify
      if (el.className && typeof el.className === 'string') {
        if (
          el.className.includes('cart__checkout') ||
          el.className.includes('checkout') ||
          el.className.includes('button--checkout')
        ) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = redirectUrl;
          return false;
        }
      }

      el = el.parentNode;
    }
  }

  function interceptSubmit(e) {
    var form = e.target;
    if (form && form.action && form.action.includes('/checkout')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = redirectUrl;
      return false;
    }
  }

  document.addEventListener('click', interceptClick, true);
  document.addEventListener('submit', interceptSubmit, true);
})();
